<template>
  <div class>
    <div class="select-question select-question_answer-select-question container">
      <div class="select-question__left flex-grow-1 flex-basis-700">
        <div class="image animation-bottom container justify-content-center align-content-stretch">
          <image-loader :src="question.img"/>
        </div>
      </div>

      <div class="select-question__right flex-grow-2 flex-basis-500">
        <div class="select_question select_question-red container align-items-stretch">
          <div class="img container align-center">
            <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class>
          </div>
          <div class="flex-grow-1 bordered-box bordered-box-orange">
            <p>{{ question.question }}</p>
          </div>
        </div>
        <div class="game-sw container">
          <div class="game-sw__speech select-question__right animation-bottom animation-delay-05 no-padding-bottom no-padding-top">
            <div class="game-sw__speech__text">
              <div>
                <span ref="answer" :style="{ color: question.answered ? '#FFF' : 'transparent' }" v-if="!question.alternative_text"> {{ question.text }} </span>
                <span ref="answer" :style="{ color: question.answered ? '#FFF' : 'transparent' }" v-else> {{ question.text }} or {{ question.alternative_text }} </span>
              </div>
            </div>
            <div class="game-sw__speech__microphone container align-center">
              <div class="config container">
                <div class="index">{{ parseInt(index) + 1 }}</div>
                <div class="checkbox" ng-click=""></div>
              </div>
              <div
                class="mic"
                :class="{ talking: talking }"
                v-if="!supportMedia"
                @click="speak()"
              >
                <div class="icon" :class="{ talking: talking }">
                  <img src="@/assets/img/icons/microphone.svg" width="46" alt="Minds" class>
                </div>
                <div class="status" :class="{ talking: talking }"></div>
              </div>
            </div>
            <div class="game-sw__speech__text">
              <div>
                <span
                  ref="text"
                  :class="{ right: question.answered && question.hit, wrong: question.answered && !question.hit }"
                >
                  {{ question.answer }}
                </span>
              </div>
              <div :style="{ visibility: (played && !question.answered) ? 'visible' : 'hidden' }">
                <button @click="confirm()">Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">
        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>
        <div v-if="question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta</span>
        </div>
        <div v-if="!question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta</span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>

<script>
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      supportMedia: false,
      talking: false,
      speech: null,
      index: 0,
      played: false,
      question: {},
      showInfo: false,
      showFeedback: false,
      ended: false
    };
  },
  computed: {
    ...mapGetters({
      testMode: "isTestMode",
      isReview: "isReview",
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    exercise() {
      return this.subTopic.exercise;
    }
  },
  props: {
    subTopic: {
      type: Object,
      default: () => ({})
    },
    topic: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  methods: {
    async setCurrent() {
      let qst = {};
      const questions = this.exercise.questions;
      for (const q_key in questions) {
        this.index = q_key;
        if (!questions[q_key].answered) {
          if (!questions[q_key].answer)
            this.$set(this.exercise.questions[q_key], "answer", "");
          qst = questions[q_key];
          this.played = false;
          break;
        } else if (parseInt(q_key) == questions.length - 1) {
          qst = questions[q_key];
          this.ended = true;
          this.played = true;
        }
      }
      if (
        Object.keys(this.question).length == 0 ||
        qst._id !== this.question._id
      ) {
        await this.$set(this, "question", qst);
        await this.syncWidth();
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    async save(question) {
      let copy = cloneDeep(question);
      let scoreQuestions = 0;
      let answered = 0;

      for (const qst of this.exercise.questions) {
        if (qst.answered) {
          answered++;

          if (qst.hit)
            scoreQuestions++;
        }
      }

      const score = (scoreQuestions * 100) / this.exercise.questions.length;

      let payload = {
        points: score,
        finished: false,
        question: { ...copy }
      };

      if (answered == this.exercise.questions.length) {
        payload.finished = true;
        this.ended = true;
        await this.$delay(1500)
        this.showInfo = true
      }

      gameBus.$emit("updateProgress", score);
      gameBus.$emit("setEnabled", true);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    },
    speak() {
      if (!this.talking && !this.question.answered) {
        this.speech.start();
      }
    },
    syncWidth (end) {
      return new Promise(async resolve => {
        try {
          await this.$delay(500);
          const text = this.$refs["text"]
          const answer = this.$refs["answer"]
          if (!answer) throw Error('answer is undefined')
          text.style["min-width"] = `${answer ? answer.offsetWidth : '50'}px`
          if (!end) resolve()
          else resolve(end())
        } catch (error) {
          await this.syncWidth(resolve)
        }
      });
    },
    async confirm() {
      this.$set(this.question, "answered", true);

      const answerReduced = this.question.answer
        .replace(/[\.?!,]+/g, "")
        .toLowerCase()
        .trim()
        .toLowerCase();

      const textReduced = this.question.text
        .replace(/[\.?!,]+/g, "")
        .toLowerCase()
        .trim()
        .toLowerCase();

      let alternativeTextCorrect = false

      if (this.question.alternative_text) {
        const alternativeTextReduced = this.question.alternative_text
          .replace(/[\.?!,]+/g, "")
          .toLowerCase()
          .trim()
          .toLowerCase();

        alternativeTextCorrect = alternativeTextReduced === answerReduced
      }

      if ((answerReduced === textReduced) || alternativeTextCorrect) this.$set(this.question, "hit", true);
      else this.$set(this.question, "hit", false);
      this.feedback()
      await this.save(this.question)
    },
    async feedback () {
      this.showFeedback = true
      await this.$delay(1500)
      this.showFeedback = false
      gameBus.$emit('setEnabled', true)
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    closeModal () {
      this.showInfo = false
    },
    async viewQuestion (index) {
      const question = this.exercise.questions[index]
      if (question && question.answered) {
        this.index = index
        // await this.verifySource(question.img)
        await this.$set(this, 'question', question)
        if (!this.question.answer) {
          this.$set(this.question, "answer", "");
        }

        this.played = !!question.answered;
        await this.syncWidth()
      }
    }
  },
  watch: {
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  beforeMount() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    let speech = new SpeechRecognition();
    speech.lang = "en-US";
    speech.interimResults = false;
    speech.maxAlternatives = 5;

    speech.onaudiostart = () => {
      this.talking = true;
    };
    speech.onend = () => {
      this.talking = false;
    };
    speech.onerror = err => {
      alert("Error getting Speech!");
    };
    speech.onresult = ev => {
      let answer = ev.results[0][0].transcript;
      this.question.answer = answer;
      this.talking = false;
      this.played = true;
    };
    this.speech = speech;
  },
  mounted() {
    this.setCurrent()
    gameBus.$on("viewQuestion", this.viewQuestion)

    gameBus.$emit("updateProgress", this.subTopic.points)
    modalBus.$on("close", this.closeModal)
    gameBus.$on("setCurrent", this.setCurrent)
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion)

    modalBus.$off('close', this.closeModal)
    gameBus.$off("setCurrent", this.setCurrent)
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/answerSelectQuestion";
$color-red: #c2003c;

.config {
  background: #d8d8d8;
  height: 42;
  width: 120px;
  padding: 8px;
  border-radius: 50px;
  transform: translateX(20px);

  .index,
  .checkbox {
    border: 1px solid #979797;
    background: #afafaf;
    color: #fff;
    width: 30px;
    min-width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin: 0 10px;
    box-sizing: border-box;
  }

  .checkbox {
    border: 3px solid #b7b7b7;
    background: #fff;
    margin-left: 0;
    cursor: pointer;
    &:hover {
      color: #f4f4f4;
    }
  }
}

.mic {
  cursor: pointer;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d8d8d8;
  position: relative;
  .talking {
    cursor: not-allowed;
  }
  .status {
    position: absolute;
    width: 170px;
    height: 170px;
    border-radius: 50%;
    border: 15px solid #ffb300;
    transition: border .2s;
    &.talking {
      border: 15px solid $color-red;
    }
  }
  .icon {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffb300;
    &.talking {
      animation: changeColorMic 2s linear infinite !important;
    }
  }
}

.game-sw {
  width: 100%;
  height: calc(100% - 100px);
  justify-content: center;
  &__speech {
    padding: 20px;
    box-sizing: border-box;
    font-size: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;
    &__microphone {
      margin-bottom: 5px;
      margin-right: 125px;
      align-self: center;
      &__enable {
        padding: 32.5px 42px;
      }
      &__disable {
        padding: 32.5px 25px;
      }
    }
    &__text {
      align-self: center;
      &:first-child {
        margin-bottom: 5px;
      }
      div {
        text-align: center;
        span {
          line-height: 37px;
          vertical-align: middle;
          display: inline-block;
          background-color: #ff9c00;
          padding: 0px 30px;
          margin: 5px;
          border-radius: 50px;
          color: #fff;
          height: 40px;
          &.right {
            background-color: #5ec12d;
          }
          &.wrong {
            background-color: $color-red;
          }
        }
        button {
          border: 2px solid #ddd;
          padding: 5px 15px;
          font-size: 16px;
          background-color: #ddd;
          border-radius: 5px;
          transition: all 0.2s;
          color: #222;
          &:active,
          &:focus {
            outline: none;
          }
          &:hover {
            color: #666;
            background-color: #fff;
          }
        }
      }
    }
    &__options {
      padding-bottom: 47.5px;
      padding-right: 30px;
      position: absolute;
      align-self: flex-end;
      bottom: 0;
    }
  }
}

@keyframes changeColorMic {
  0% {
    background-color: $color-red;
  }
  25% {
    background-color: lighten($color-red, 5);
  }
  50% {
    background-color: $color-red;
  }
  75% {
    background-color: darken($color-red, 10);
  }
  100% {
    background-color: $color-red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/speakWordGame.vue